const { TCGPartnerKey } = require('/src/services').Configuration;
const { Cards } = require('../../services');
const Tracker = require('../navigation/tracker');
const template = require('./buy-link.tpl').default;

const tracker = new Tracker();

const price = value => isNaN(value) ? 0 : Number(value);

module.exports = DomClass(template, function BuyLinks() {
	var _t = this;

	this.cards = [];
	this.cart = [];
	
	this.load = async function(cards) {
		this.cart = [];
		this.cards = cards || [];
		for (const card of cards) {
			// should we emit an error or event of some sort
			// to highlight cards without prices when `addCard()` fails?
			await _t.addCard(card);
			await _t.updateLink();
		};
	};

	/**
	 * @param {*} card A card object that may or may not have `prices`,
	 * but which *must* have a `name`.
	 */
	this.addCard = async function(card) {
		try {
			prices = card.prices || (await Cards.get(card.name)).prices || {};
			this.cart.push({
				name: card.name,
				quantity: card.quantity,
				lowPrice: prices.low,
				avgPrice: prices.average,
				highPrice: prices.high
			});
			return true;
		} catch {
			return false;
		}
	};

	this.updateLink = function() {
		var lowPrice = 0;
		var avgPrice = 0;
		var highPrice = 0;
		var unknown = '?.??';

		var link = 'http://store.tcgplayer.com/massentry?'
			+ 'partner=' + TCGPartnerKey
			+ '&utm_campaign=affiliate'
			+ '&utm_medium=' + TCGPartnerKey
			+ '&utm_source=' + TCGPartnerKey
			+ '&c=' + this.cart.map(function(card){
				var quantity = 1;
				if (typeof(card.quantity) == 'number') {
					quantity = card.quantity;
				} else {
					quantity = card.quantity || quantity;
				}

				lowPrice += quantity * price(card.lowPrice);
				avgPrice += quantity * price(card.avgPrice);
				highPrice += quantity * price(card.highPrice);

				return quantity + ' ' + card.name.split('//')[0].trim();
			}).join('||')
		;

		this.buyTCGLink = link;
		this.lowPrice = lowPrice ? lowPrice.toFixed(2) : unknown;
		this.avgPrice = avgPrice ? avgPrice.toFixed(2) : unknown;
		this.highPrice = highPrice ? highPrice.toFixed(2) : unknown;
	};

	this.__dom.buyTCGLink.onclick = () => {
		tracker.trackBeginCheckout('TCGPlayer', this.cards.map(card => ({
			name: card.name,
			quantity: card.quantity || 1,
			price: (price(card.lowPrice) + price(card.avgPrice)) / 2
		})));
		return true;
	}

});
